"use strict";

exports.__esModule = true;
exports.default = stop;
//  weak

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    Object.keys(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/react-move/core/transition/stop.js
// module id = 666
// module chunks = 35783957827783